import React, { JSX } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { AccountCircle, EmojiEvents, LiveHelp, School, Work } from '@mui/icons-material';

interface TabPanelProps {
  children?: React.ReactNode;
  value: string;
  active: string;
}

function TabPanel({ children, value, active, ...other }: TabPanelProps): JSX.Element {
  return (
    <div
      role="tabpanel"
      hidden={active !== value}
      id={`profile-tabpanel-${value}`}
      aria-labelledby={`profile-tab-${value}`}
      {...other}
    >
      {value === active && (
        <Box sx={{ p: { xs: 1, sm: 3 }, maxWidth: '100%', overflow: 'hidden' }}>{children}</Box>
      )}
    </div>
  );
}

interface ProfileTabsProps {
  tabValue: string;
  isMobile: boolean;
  onChange: (event: React.SyntheticEvent, newValue: string) => void;
}

function ProfileTabs({ tabValue, isMobile, onChange }: ProfileTabsProps): JSX.Element {
  const iconPos = isMobile ? 'top' : 'start';
  const iconSx = { fontSize: { xs: 18, sm: 24 } };
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Tabs
        value={tabValue}
        onChange={onChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          '& .MuiTabs-flexContainer': { justifyContent: isMobile ? 'flex-start' : 'center' },
          '& .MuiTab-root': {
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
            minWidth: { xs: 60, sm: 120 },
            padding: { xs: '6px 8px', sm: '12px 16px' },
          },
        }}
      >
        <Tab
          label={isMobile ? 'Info' : 'Basic Info'}
          value="info"
          icon={<AccountCircle sx={iconSx} />}
          iconPosition={iconPos}
        />
        <Tab
          label="Questions"
          value="questions"
          icon={<LiveHelp sx={iconSx} />}
          iconPosition={iconPos}
        />
        <Tab
          label="Skills"
          value="skills"
          icon={<EmojiEvents sx={iconSx} />}
          iconPosition={iconPos}
        />
        <Tab
          label={isMobile ? 'Work' : 'Experience'}
          value="experience"
          icon={<Work sx={iconSx} />}
          iconPosition={iconPos}
        />
        <Tab
          label={isMobile ? 'Edu' : 'Education'}
          value="education"
          icon={<School sx={iconSx} />}
          iconPosition={iconPos}
        />
      </Tabs>
    </Box>
  );
}

export { ProfileTabs, TabPanel };
